import React from 'react';

import { ICreditCardFormTitle } from './credit-card-form-title.types';

const CreditCardFormTitle: React.FC<React.PropsWithChildren<ICreditCardFormTitle>> = () => null;

export default CreditCardFormTitle;
